export default __webpack_public_path__ + "static/8-aefbdfd57955fcc9b0497755d0693b3d.jpg";